module.exports = __webpack_public_path__ + "img/pro_six_2.c385d38c.jpg";